import { Box, Modal, Tooltip } from "@mui/material";
import { useMemo, useState } from "react";
import { COLORS, DataGridBox } from "../../ui/Theme";
import TableActions from "./TableActions";
import { blueGrey } from "@mui/material/colors";
import CustomToolbar from "./CustomToolbar";

const modalStyles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "95%",
    width: 1000,
    background: blueGrey[50],
    borderRadius: "20px",
    p: 1.5,
};

const Table = ({
    tableData,
    Form,
    faCols,
    highlightedCols,
    percentCols,
    isCheckboxSelection,
    isRowSelection,
    handleSelectedTableData,
    height,
    tableTitle,
    onDeleteRow,
    isActions,
    Chart,
    pointer,
}) => {
    // const [selectedRowId, setSelectedRowId] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const { data = [], isValidating, isLoading } = tableData;

    const handleShowChart = (data) => {
        setRowData(data);
        setOpenModal(true);
    };

    const cols = useMemo(() => {
        if (!Array.isArray(data) || data.length === 0) return [];

        const keys = Object.keys(data[0])
            .filter((key) => faCols[key])
            .map((key) => {
                return {
                    field: key,
                    headerName: faCols[key] || key,
                    headerAlign: "center",
                    align: "center",
                    disableColumnMenu: true,
                    minWidth: key === "id" ? 50 : 200,
                    flex: 1,

                    renderHeader: (params) => (
                        <div
                            style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                textAlign: "center",
                                lineHeight: 1.2,
                                width: "100%",
                            }}
                        >
                            {params?.colDef?.headerName}
                        </div>
                    ),
                    renderCell: (params) => {
                        const isNumber = typeof params.value === "number";
                        const value = params.value ?? "";
                        let style = {
                            color: key === "symbol" ? COLORS.BLUE : undefined,
                            whiteSpace: "normal",
                            textAlign: "center",
                            wordWrap: "break-word",
                            width: "100%",
                            display: "block",
                        };

                        if (highlightedCols?.includes(key) && isNumber) {
                            style.color =
                                value > 0 ? "#00af00" : value < 0 ? COLORS.RED : "black";
                        }

                        let displayedValue = isNumber
                            ? value.toLocaleString("fa-IR")
                            : value;

                        if (percentCols?.includes(key) && isNumber) {
                            displayedValue = `${displayedValue}%`;
                        }
                        if (key === "deviation" && isNumber) style.color = value < 0 ? COLORS.RED : COLORS.GREEN

                        return (
                            <Tooltip title={displayedValue}>
                                <span style={style}>{displayedValue}</span>
                            </Tooltip>
                        );
                    },
                };
            });

        if (isActions) {
            keys.splice(1, 0, {
                field: "actions",
                headerName: "عملیات",
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                maxWidth: 120,
                renderHeader: () => (
                    <div
                        style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            textAlign: "center",
                            width: "100%",
                        }}
                    >
                        عملیات
                    </div>
                ),
                renderCell: (params) => (
                    <TableActions
                        rowData={params.row}
                        onDelete={onDeleteRow}
                        onShowChart={handleShowChart}
                    />
                ),
            });
        }

        return keys;
    }, [data, faCols, highlightedCols, percentCols, isActions]);

    const handleRowClick = (params) => {
        handleSelectedTableData(params.row);
        // setSelectedRowId(params.row.id);
    };

    return (
        <>
            <Box sx={{ height: height }}>
                <DataGridBox
                    sx={{
                        "& .MuiDataGrid-row": {
                            cursor: pointer ? "pointer" : "default",
                        },
                    }}
                    getRowHeight={() => 'auto'}
                    loading={isLoading || isValidating}
                    rows={data}
                    columns={cols}
                    getRowId={(row) => row.id}
                    onRowClick={isRowSelection && handleRowClick}
                    checkboxSelection={isCheckboxSelection}
                    disableRowSelectionOnClick={!isRowSelection}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                    slotProps={{
                        toolbar: {
                            Form,
                            tableTitle,
                        },
                    }}
                />
            </Box>

            {rowData?.chart && (
                <Modal open={openModal} onClose={() => setOpenModal(false)}>
                    <Box sx={modalStyles}>
                        <Chart chartData={rowData.chart} />
                    </Box>
                </Modal>
            )}
        </>
    );
};

export default Table;
